import { LearningsPanel } from '@/components/knowledge/LearningsPanel';
import { useIsStaff } from '@/app/store';
import { api } from '@/lib/api';
import { useProjectCtx } from './ProjectLayout';

/** Workstream-scoped learnings — apply to this project only. */
export function ProjectKnowledgeTab() {
  const { project } = useProjectCtx();
  const isStaff = useIsStaff();
  return (
    <LearningsPanel
      canEdit={isStaff}
      source={{
        key: `pr-${project.id}`,
        list: (archived) => api.listProjectKnowledge(project.id, archived),
        create: (body) => api.createProjectLearning(project.id, body),
        scopeLabel: 'workstream',
        emptyDescription: 'Learnings here apply to this workstream only.',
      }}
    />
  );
}
